import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectNonFixedInstumentStrikesResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_INSTRUMENT_STRIKES_RESPONSE);
        // когда имя фьючерса (и каждого страйка) может прис
        this.FutureAliasName = null;
        this.useAliasName = false;
    }
}
